const { min, abs, round } = Math;

export const percentToHex = (percent: number) => {
  const hex = round(min(abs(percent), 100) * 2.55).toString(16);

  return hex.padStart(2, '0');
};
